/**
 * A styled vertically scrollable `Box`
 */
import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import theme from 'styled-theming';

export const scrollThumbBG = theme('mode', {
  light: (props: any) => props.theme.colors.greyLight,
  dark: (props: any) => props.theme.colors.paynesGrey,
});

export const scrollBG = theme('mode', {
  light: (props: any) => props.theme.colors.auroMetalSaurus,
  dark: (props: any) => props.theme.colors.auroMetalSaurus,
});

const ScrollBoxStyled = styled(Box)`
  height: 100%;
  width: 100%;
  overflow-y: overlay;
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.02);
  }
  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${scrollThumbBG};
    outline: none;
    border-radius: 8px;

    &:hover {
      background-color: ${scrollBG};
    }
  }
`;

export default ScrollBoxStyled;
